import React from '../../vendor/react';
import { AlertTriangle, CircleCheck } from '../../vendor/lucide-react';

export function AuthNotice({ tone = 'info', children }: { tone?: 'info' | 'error' | 'success'; children?: unknown }) {
  return <div className={`auth-notice auth-notice--${tone}`}>{tone === 'error' ? <AlertTriangle size={17} /> : <CircleCheck size={17} />}<span>{children}</span></div>;
}
